import React from "react";

const SvgAndroid = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="currentColor"
    {...props}
  >
    <path d="M19.653 6.345c2.3 1.07 3.856 3.1 3.856 5.422H8.336c0-2.323 1.556-4.352 3.856-5.423l-.306-.458-.301-.451-.675-1.014a.271.271 0 0 1 .45-.3l.726 1.087.304.457.308.463a8.921 8.921 0 0 1 3.223-.593c1.153 0 2.245.213 3.225.593l.309-.463.304-.457.724-1.087a.271.271 0 1 1 .452.3l-.676 1.014-.3.452-.306.458zM12.67 9.6a.812.812 0 1 0 0-1.625.812.812 0 0 0 0 1.625zm6.502 0a.813.813 0 1 0 .002-1.625.813.813 0 0 0-.002 1.625zm-10.72 3.252H23.509v11.922c0 .946-.77 1.716-1.716 1.716h-1.239c.042.143.065.295.065.451v3.433a1.626 1.626 0 0 1-3.252 0V26.942c0-.157.023-.309.065-.452h-3.019c.04.143.064.295.064.451v3.433a1.626 1.626 0 0 1-3.252 0V26.942c0-.157.024-.309.065-.452h-1.239c-.946 0-1.715-.77-1.715-1.716V12.852h.117zm-2.827 0c.897 0 1.625.727 1.625 1.625v6.955a1.626 1.626 0 0 1-3.251 0v-6.954c0-.899.728-1.626 1.626-1.626zm20.593 0c.897 0 1.625.727 1.625 1.625v6.955a1.625 1.625 0 1 1-3.25 0v-6.954c0-.899.727-1.626 1.625-1.626z" />
  </svg>
);

export default SvgAndroid;
